import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useProductInfo } from 'product/services/productInfo/client'
import { useCallback, useEffect, useMemo, useState } from 'react'
import type { SelectedSize } from '../../SizesList/SizesList'

export function useSelectedRelatedSize(
	handleBackInStock: (selected: {
		product: string
		size: string
		name: string
		color: string
	}) => void,
	productId: string
) {
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const [relatedSelected, setRelatedSelected] = useState<SelectedSize | null>(
		null
	)

	const { data: relatedProductInfo, isLoading } = useProductInfo({
		productId: relatedSelected?.size.relatedProductId ?? '',
		country: countryISO,
		language: languageISO,
		enabled: !!relatedSelected,
	})

	const resetRelatedSelected = useCallback(
		(selected: SelectedSize, name: string) => {
			handleBackInStock({
				color: selected.color,
				product: selected?.size.relatedProductId ?? productId,
				size: selected.size.id,
				name,
			})
			setRelatedSelected(null)
		},
		[handleBackInStock, productId]
	)

	useEffect(() => {
		if (relatedSelected && relatedProductInfo && !isLoading) {
			resetRelatedSelected(relatedSelected, relatedProductInfo.name)
		}
	}, [relatedSelected, relatedProductInfo, isLoading, resetRelatedSelected])

	return useMemo(
		() => ({
			setRelatedSelected,
		}),
		[]
	)
}
